/**
 * {CheckoutPageRequirementsConfig}
 * @param {PageRequirements} pageRequirements
 * @constructor
 */
var CheckoutPageRequirementsConfig = function (pageRequirements) {
    let self = this;
    /**
     *
     * @type {{PageRuleIsFor: {ServerRequirementName: 'RequiredPage'}}}
     */
    self.config = {
        '/secure/checkout/v2#/payment': {
            'loginRequiredForPayment': '/login?redirect=' + encodeURIComponent(
                '/secure/checkout/v2#/payment'
            ) + '&checking-out=true',
            'CONFERENCE_PRODUCTS_INVALID': '/conference-tickets',
            // 'billAddressRequired': '/secure/checkout/v1#/checkout/address',
            // 'billAddressVerified': '/secure/checkout/v1#/checkout/address',
            // 'shipAddressRequired': '/secure/checkout/v1#/checkout/address',
            // 'shipAddressVerified': '/secure/checkout/v1#/checkout/address',
            'cartItemsRequired': '/empty-cart',
            'enrollmentKitSelectRequired': '/secure/checkout/v1#/checkout/dist-kits-select',
            'idImageRequired': '/id-image-upload',
        },
        '/secure/checkout/v1#/checkout/cart': {
            'loginRequiredForCart': '/login?redirect=' + encodeURIComponent(
                '/cart#/my-cart'
            ),
            'CONFERENCE_PRODUCTS_INVALID': '/conference-tickets',
            'cartItemsRequired': '/empty-cart',
        },
        '/secure/checkout/v1#/checkout/address': {
            'loginRequiredForCart': '/login?redirect=' + encodeURIComponent(
                '/cart#/my-cart'
            ),
        },
        '/secure/checkout/v1#/checkout/dist-kits-select': {
            'enrollmentKitSelectNotAllowed': '/not-found',
            'enrollmentCreationMethodRequired': '/checkout/distributor',
        },
        '/cart#/my-cartv2': {
            'idImageRequired': '/id-image-upload',
            "enrollmentKitSelectRequired": "/secure/checkout/v1#/checkout/dist-kits-select",
            // 'billAddressRequired': '/secure/checkout/v1#/checkout/address',
            'CONFERENCE_PRODUCTS_INVALID': '/conference-tickets',
            // 'billAddressVerified': '/secure/checkout/v1#/checkout/address',
            // 'shipAddressRequired': '/secure/checkout/v1#/checkout/address',
            // 'shipAddressVerified': '/secure/checkout/v1#/checkout/address',
        }
    };

    pageRequirements.finalPage = '/cart#/my-cartv2';

    self.configure = function () {
        angular.forEach(
            self.config,
            function (requirement, uriPath) {
                angular.forEach(
                    requirement,
                    function (requiredPage, requirementName) {
                        pageRequirements.add(
                            uriPath,
                            requirementName,
                            requiredPage
                        );
                    }
                );
            }
        );
    };
};

/**
 * pageRequirementsConfig
 */
angular.module('checkout').factory(
    'pageRequirementsConfig',
    [
        'pageRequirements',
        function (pageRequirements) {
            return new CheckoutPageRequirementsConfig(pageRequirements);
        },
    ]
);
